const tableHeaders = [
  {
    label: 'user-id',
    key: 'userId',
    sortable: false,
  },
  {
    label: 'action',
    key: 'action',
    sortable: false,
  },
  {
    label: 'Submitted By',
    key: 'addedBy',
    sortable: false,
  },
  {
    label: 'first-name',
    key: 'firstName',
    sortable: false,
  },
  {
    label: 'last-name',
    key: 'lastName',
    sortable: false,
  },
  {
    label: 'Role Type',
    key: 'roleType',
    sortable: false,
  },
  {
    label: 'status',
    key: 'overAllStatus',
    sortable: false,
  },
  {
    label: 'last-updated',
    filter: 'date',
    key: 'updatedAt',
    sortable: false,
  },
  {
    label: 'View Request',
    key: 'view',
    sortable: false,
  },
];

export default () => tableHeaders;
